import { render, staticRenderFns } from "./OtherAccidentCard.vue?vue&type=template&id=17a44e72"
import script from "./OtherAccidentCard.vue?vue&type=script&lang=js"
export * from "./OtherAccidentCard.vue?vue&type=script&lang=js"
import style0 from "./OtherAccidentCard.vue?vue&type=style&index=0&id=17a44e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports